import { EventBus } from "../../../eventbus";
import { baseUrl, videoExtensions } from "../../../config.js";
import { thumbnail, placeholderThumb } from "../../../functions/thumbnail";
import PSD from "psd.js";
import VueLoadImage from "vue-load-image";

export default {
  props: {
    file: [Object, String],
  },
  components: {
    "vue-load-image": VueLoadImage,
  },

  data() {
    return {
      videoPlaying: false,
      isCollectedForDownload: false,
      realFile: {},
      dataThumb: false,
      audioRef: false,
    };
  },
  created() {
    this.setRealFile();
    EventBus.$on(`right-sidebar-close`, () => this.close());
  },

  methods: {
    setUrlEmbedType() {
      if (this.realFile.location && this.realFile.extension === ".url") {
        if (
          this.realFile.location.match(
            /https:\/\/([\w\.-]+\.)?figma.com\/(file|proto)\/([0-9a-zA-Z]{22,128})(?:\/.*)?$/
          )
        ) {
          this.realFile.extension = ".figma";
        }
      }
    },
    isVideo(extension) {
      return videoExtensions.includes(extension);
    },
    setRealFile() {
      if (typeof this.file === "object") {
        this.realFile = this.file;

        this.setUrlEmbedType();

        this.setPsdPreview();
        this.setUrl();
      } else {
        this.$axios
          .get(
            `${baseUrl}/file?file=${this.file.id}&myspace=${
              this.$route.path.includes("myspace") ? 1 : 0
            }`,
            {
              responseType: "json",
            }
          )
          .then((r) => {
            //get file
            this.realFile = r.data;

            this.setUrlEmbedType();

            this.setPsdPreview();
            this.setUrl();
          });
      }
    },
    showFull() {
      this.$router.push(
        `/${this.$store.state.company}/${
          this.realFile.myspace ? "myspace" : "home"
        }/expanded/${this.realFile.folder_id}/${
          this.realFile.file_id ? this.realFile.file_id : this.realFile.id
        }/detail`
      );
    },
    showSlider() {
      EventBus.$emit(`image-slider--open`, this.file.id);
    },
    createDownloadLink() {
      let downloadLink = `${baseUrl}/download?file=${this.realFile.id}`;

      downloadLink += `&company=${this.$store.state.company}`;
      downloadLink += `&myspace=${this.realFile.myspace}`;

      if (this.$store.state.user) {
        downloadLink += `&key=${this.$store.state.user.key}`;
      }

      return downloadLink;
    },
    setPsdPreview() {
      this.dataThumb = false;

      if (this.realFile.extension) {
        if (this.realFile.extension.toLowerCase().replace(".", "") === "psd") {
          PSD.fromURL(this.createDownloadLink()).then((psd) => {
            if (psd.image.toPng().src) {
              this.dataThumb = psd.image.toPng().src;
            }
          });
        }
      }
    },
    setUrl() {
      if (this.$route.path.includes("collection")) {
        this.$router.push(
          `/${this.$store.state.company}/collection/expanded/${this.$route.params.id}/${this.realFile.id}`
        );
      } else if (this.$route.path.includes("search")) {
        this.$router.push(
          `/${this.$store.state.company}/search/${this.$route.params.query}/${this.realFile.id}`
        );
      } else {
        this.$router.push(
          `/${this.$store.state.company}/${
            this.realFile.myspace ? "myspace" : "home"
          }/expanded/${this.realFile.folder_id}/${this.realFile.id}`
        );
      }
    },

    playPause() {
      if (this.$refs.video) {
        if (this.realFile.duration) {
          if (this.videoPlaying) {
            this.$refs.video.pause();
            this.videoPlaying = false;
          } else {
            this.$refs.video.play();
            this.videoPlaying = true;
          }
        }
      }
    },

    thumb(item) {
      return thumbnail(item);
    },

    deleteTag(tagid) {
      let formData = new FormData();
      formData.append("tag", tagid);
      formData.append("myspace", this.realFile.myspace);

      this.$axios.post(baseUrl + "/tagdelete", formData).then((response) => {
        for (var i = 0; i < this.realFile.tags.length; i++) {
          if (this.realFile.tags[i].id == tagid) {
            this.realFile.tags.splice(i, 1);
          }
        }
      });
    },
    addTag() {
      let formData = new FormData();
      formData.append("tagname", this.newtag);
      formData.append("file", this.realFile.id);
      formData.append("myspace", this.realFile.myspace);

      this.$axios.post(baseUrl + "/tagadd", formData).then((response) => {
        if (response.data) {
          this.newtag = "";
          this.realFile.tags.push(response.data);
          this.canAdd = false;
        }
      });
    },
    tagComponent() {
      EventBus.$emit("closeallactions");
      EventBus.$emit("tag", this.realFile.id);
    },
    activateFace(id) {
      this.activeFace = id;
      for (var i = 0; i < this.realFile.faces.length; i++) {
        if (this.realFile.faces[i].id == this.activeFace) {
          this.personName = this.realFile.faces[i].name;
        }
      }
    },

    downloadFile(e, specialAttrs = []) {
      e.preventDefault();

      if (!this.isDownloading) {
        this.isDownloading = true;

        download(
          {
            type: "file",
            item: this.realFile,
            specialAttrs: specialAttrs,
          },
          this
        )
          .then(() => {
            this.isDownloading = false;
          })
          .catch((error) => {
            this.isDownloading = false;
            errorDispatch("dowload_file");
          });
      }
    },
    addFace() {
      let formData = new FormData();
      formData.append("id", this.activeFace);
      formData.append("facename", this.personName);
      formData.append("myspace", this.realFile.myspace);
      this.$axios.post(baseUrl + "/faceadd", formData).then((response) => {
        for (var i = 0; i < this.realFile.faces.length; i++) {
          if (this.realFile.faces[i].id == this.activeFace) {
            this.realFile.faces[i].name = this.personName;
            this.activeFace = null;
          }
        }
      });
    },
    setActiveFace(id) {
      this.activeFace = id;
    },
    deleteFace(faceid) {
      let formData = new FormData();
      formData.append("face", faceid);
      formData.append("file", this.realFile.id);
      formData.append("myspace", this.realFile.myspace);

      this.$axios.post(baseUrl + "/facedelete", formData).then((response) => {
        for (var i = 0; i < this.realFile.faces.length; i++) {
          if (this.realFile.faces[i].id == faceid) {
            this.realFile.faces[i].name = null;
            this.activeFace = null;
          }
        }
      });
    },
    crop() {
      EventBus.$emit("closeallactions");
      EventBus.$emit(
        "crop",
        this.realFile.file_id ? this.realFile.file_id : this.realFile.id
      );
    },
    extensionCheck() {
      return this.realFile.extension
        ? this.setExtensions.filter((ext) => ext === this.realFile.extension)
            .length > 0
        : true;
    },
  },
  computed: {
    getActions() {
      return this.actions.filter((action) =>
        userHasAllRights(action.rights, this)
      );
    },
    dateAdded() {
      if (this.realFile) {
        const date = new Date(this.realFile.created_at.replace(/-/g, "/"));

        return `${addLeadingZero(date.getDate())}/${addLeadingZero(
          date.getMonth() + 1
        )}/${date.getFullYear()}`;
      }

      return false;
    },
    onError() {
      return placeholderThumb();
    },
  },
  watch: {
    file() {
      this.setRealFile();
    },
    realFile() {},
  },
};
